import clsx from "clsx"
export default function Play({ className = '' }) {
  return (
    <svg className={clsx(className, 'w-9 h-auto')} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#38362D"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M13 26L27 18L13 10V26ZM15 13.4464V22.5536L22.9689 18L15 13.4464Z" fill="white"/>
    </svg>
  )
}
